export default {
  orderchange: {
    searchPlaceholder: '输入商品名或订单编号或供应商进行搜索',
    purchaseNoChg: '订单单号',
    purchaseChgDate: '变更日期',
    purchaseChgNo: '变更单号',
    purchaseChgbanbeng: '变更版本',
    supplierName: '供应商',
    purOfficeName: '采购中心',
    employeeNameAfter: '采购人员',
    employeeNo: '采购人员',
    employeeName: '采购人员',
    taxRateMark: '税率',
    taxTypeNameMark: '税种',
    currencyNameMark: '币种',
    txTermsNameMark: '交易条件',
    dataSourceMark: '数据来源',
    outPurchaseNoMark: '外部订单',
    remarksMark: '备注',
    remarks: '备注',
    period1: '变更前',
    period2: '变更后',
    liaohao: '料号',
    goodsName: '品名',
    spec: '规格',
    outPurchaseNo: '外部单号',
    purchaseUnitNo: '采购中心',
    purchaseNo: '项次-项序',
    purchaseNoX: '项次-项序-分批序',
    goodsInfo: '产品信息',
    batchPurMark: '订单量',
    batchValuationMark: '计价数量',
    priceMark: '含税单价',
    batchTaxIncludedAmountMark: '含税金额',
    batchPreTaxAmountMark: '税前金额',
    batchTaxAmountMark: '税额',
    arrivalDateMark: '预计交货日期',
    unreceivedAmount: '外部变更单项次-项序-分批序',
    dataSource: '变更类型',
    chgReason: '变更原因',
    goodsNo: '料号',
    purchaseDate: '变更日期范围',
    deliveryDate: '交货日期范围',
    unitNo: '单位',
    valuationUnitNo: '计价单位'
  },
  labelprinting: {
    docNo: '单号',
    docDate: '日期',
    purchaseNo: '订单单号',
    purOfficeName: '采购中心',
    supplierNo: '供应商编号',
    supplierName: '供应商名称',
    goodsNo: '料号',
    goodsName: '品名',
    spec: '规格',
    barRuleName: '编码规则',
    unitNo: '单位',
    stockUnitNo: '库存单位',
    lotNo: '条码批号',
    batchDescription: '批次说明',
    qty: '数量',
    packQty: '单包数量',
    printerTimes: '打印时机',
    purchaseUnitNo: '采购中心',
    print: '打印列表',
    printTemplate: '打印模板',
    allQty: '订单总数',
    printerCount: '张数',
    overqty: '数量累加不可大于订单总量',
    overpackqty: '单包数量不可大于数量',
    addData: '请先加入打印数据',
    remove: '整单删除'
  },
  productionreport: {
    searchPlaceholder: '请输入申报单号查询',
    reportNo: '申报单号',
    editionNo: '版次号',
    reportTime: '申报日期',
    purchaseNo: '订单编号',
    purchaseDate: '采购日期',
    purchaseSeq: '项次',
    goodsNo: '料号',
    goodsName: '品名',
    spec: '规格',
    purchaseQty: '订单数量',
    stockQty: '库存量',
    producingQty: '在制量',
    finishedQty: '完工量',
    shippedQty: '出货量',
    differenceValue: '正负',
    supOfficeNo: '供应商',
    adddate: '创建时间',
    addByName: '创建人员',
    latestOrHistory: '最新/历史',
    latest: '最新',
    history: '历史',
    detail: '生产进度申报单明细'
  },
  ordertrack: {
    expectArrivalDate: '预计交货日期',
    ticketStatus: '开票状态',
    CheckTheState: '对账状态',
    differenceType: '差错类别',
    searchPlaceholder: '输入商品名或订单编号进行搜索',
    purchaseNo: '订单单号',
    purchaseDate: '订单日期',
    purOfficeName: '采购中心',
    purChasingCenter: '采购中心',
    supplierName: '供应商',
    purchaseSeqAndPurchasePhaseSeq: '项次-项序-分批序',
    goodsNo: '料号',
    purchaseUnitName: '采购商',
    goodsName: '品名',
    grant: '发放',
    spec: '规格',
    batchPurQty: '订单量',
    undeliveredQty: '可发货量',
    unReceiveQty: '未交量',
    shipmentQty: '发货量',
    onWayQty: '在途量',
    expectedArrivalDate: '预计交货日期',
    replyDeliveryNum: '交期回复次数',
    statusName: '状态',
    purchaseUnitNo: '采购中心',
    purchaseDateRange: '订单日期范围',
    startPurchaseDate: '订单日期-起',
    endPurchaseDate: '订单日期-止',
    expectArrivalDateRange: '交货日期范围',
    startDeliveryDate: '交货日期-起',
    endDeliveryDate: '交货日期-止',
    outPurchaseNo: '外部单号',
    employeeInfo: '采购员',
    orderType: '订单性质',
    orderTypePlaceholder: '请选择订单性质',
    overdueFlag: '仅显示逾期未交订单',
    purchaserFlag: '仅显示当前采购员订单',
    fildName: '订单信息',
    headInfo: '基础信息',
    addressStr: '地址',
    contacts: '客户联络人',
    contactPhone: '联系方式',
    employeeName: '采购人员',
    remarks: '备注',
    dataSource: '数据来源',
    taxInfo: '交易币种/汇率',
    txTermsName: '交易条件',
    payTermsName: '付款条件',
    totalAmountPreTaxPur: '未税金额',
    totalPurAmount: '税额',
    totalTaxIncludedPur: '含税总金额',
    customerInformation: '客户资料',
    documentInformation: '单据资料',
    paymentInformation: '付款信息',
    purchaseDetail: '订单详情',
    purchaseSeq: '项次',
    purchasePhaseSeq: '项序',
    batchValuationQty: '计价数量',
    unitPrice: '含税单价',
    tableTaxInfo: '未含税/含税/税额',
    taxTypeInfo: '税种/税率',
    receiveQty: '收货量',
    refundQty: '验退量',
    returnExchangeQty: '退换货量',
    lookDelivery: '查看交期',
    lookContent: '查看详情',
    deliveryTitle: '分批明细',
    supReplyQty: '答交数量',
    supReplyDate: '答交日期',
    supReplyRemark: '备注',
    approvalRecord: '审批记录',
    operationUser: '操作人',
    operation: '操作',
    adddate: '时间',
    rejectReason: '拒绝原因',
    status0: '待确认',
    status1: '需对平',
    status2: '双方确认',
    status3: '待开票',
    status4: '已开票'
  },
  purchasereply: {
    purchaseSeqAndPurchasePhaseSeq: '项次-项序-分批序',
    searchPlaceholder: '商品名/订单编号/供应商',
    purchaseUnitNo: '采购中心',
    dataRange: '答交日期',
    dataRange1: '订单日期',
    dataRange2: '交货日期',
    spec: '规格',
    outPurchaseNo: '外部单号',
    overdueFlag: '是否逾期',
    purAgreeDate: '预计交货日期',
    supReplyDate: '答交日期',
    purchaseNo: '订单单号',
    purOfficeName: '采购中心',
    supOfficeName: '供应商',
    purchaseSeq: '项次',
    purchasePhaseSeq: '项序',
    supReplyQty: '答交数量',
    supReplyRemark: '回复备注',
    goodsNo: '料号',
    goodsName: '品名',
    purchaseQty: '订单量',
    replyNum: '交期回复次数',
    dataSource: '数据来源',
    purchaseUnitName: '采购中心',
    supplierName: '供应商',
    batchPurQty: '订单量',
    expectArrivalDate: '预计交货日期',
    unitNo: '单位'
  },
  externalcontrol: {
    searchPlaceholder: '输入外检申请单号进行搜索',
    checkApplyNo: '外检单号',
    applyDate: '申请日期',
    supOfficeName: '供应商',
    purOfficeName: '采购中心',
    purchaseNo: '订单号',
    purchaseSeq: '项次',
    purchasePhaseSeq: '项序',
    goodsNo: '料号',
    goodsName: '品名',
    spec: '规格',
    applyQty: '申请量',
    qualifiedQty: '合格量',
    checkStatus: '状态',
    startApplyDate: '申请日期-起',
    endApplyDate: '申请日期-止',
    inspectionRecord: '检验记录',
    checkFrequency: '检验次数',
    adddate: '检验时间',
    inspection: '检验',
    inspectionConfirm: '检验确认',
    qualifiedQtyLabel: '本次合格数量',
    validatorMsg: '合格数量应该输入正数！',
    confirm: '确认',
    confirmInfo: '是否确认',
    checkStatus1: '待审核',
    checkStatus2: '待确认',
    checkStatus3: '待验收',
    checkStatus4: '合格'
  },
  outorderissue: {
    searchPlaceholder: '成品料号/成品品名/成品规格/订单号/供应商',
    productGoodsNo: '成品料号',
    productGoodsName: '成品品名',
    productSpec: '成品规格',
    purchaseNo: '订单单号',
    purchaseDate: '单据日期',
    docNo: '委外工单号',
    purOfficeName: '采购中心',
    supplierName: '供应商',
    finishedGoodsNo: '成品料号',
    finishedGoodsName: '成品品名',
    finishedSpec: '成品规格',
    productUnitNo: '成品单位',
    expectedAmount: '预计产量',
    numCollars: '已领套数',
    goodsNo: '材料料号',
    goodsName: '材料品名',
    spec: '材料规格',
    unitNo: '材料单位',
    needsAmount: '需领用量',
    usedAmount: '已领用量',
    unreceivedAmount: '未领用量',
    purchaseDateStart: '订单日期-起',
    purchaseDateEnd: '订单日期-止',
    deliveryDateStart: '交货日期-起',
    deliveryDateEnd: '交货日期-止',
    issueNo: '发料单号',
    documentDate: '发料日期',
    issueQty: '发料数量',
    detailTitle: '基础信息',
    listTitle: '发料信息',
    purchaseDateRange: '订单日期范围',
    expectArrivalDateRange: '交货日期范围'
  },
  deliveryschedule: {
    searchPlaceholder: '品名/订单单号',
    orderType: '订单性质',
    requiredOrderType: '请选择订单性质',
    qtyType: '未交货物资',
    haveGoodsSign: '仅显示有交货日期物资',
    purchaseUnitNo: '采购中心 ',
    requiredPurchaseUnitNo: '请选择采购中心',
    clearDataTip: '更改采购中心会清空所选数据',
    expectArrivalDateRange: '预计交货日期范围',
    goodsNo: '料号',
    goodsName: '品名',
    spec: '规格',
    purchaseUnitName: '采购中心',
    plantNo: '工厂',
    purQty: '订单数量',
    unDeliveryQty: '应交数量',
    deliveryQty: '发货数量',
    receiveQty: '收货数量',
    count: '数量',
    noData: '暂无数据',
    deliverStatus: '发货状态',
    statusText: ['', '可发货', '部分发货', '已发货'],
    beforeAfterDay: '查看前后天数',
    day0: '无',
    day7: '7天',
    day15: '15天',
    day30: '30天',
    rquiredValidDate: '至少选择预计交货日期范围或者查看前后天数',
    supplierNo: '供应商',
    getTotal: '汇总',
    totalOrder: '总订单',
    itemInformation: '料件信息',
    tatalRequiredNum: '总需求量',
    purchaserSign: '当前采购员物资'
  },
  purchaseCallMaterial: {
    placeholderContent: '订单、料件',
    itemNo: '料号',
    promiseDateRange: '承诺日期',
    promiseDateStart: '承诺日期-起',
    promiseDateEnd: '承诺日期-止',
    table: {
      docNo: '订单号',
      seq: '项次',
      itemNo: '料号',
      itemName: '品名',
      spec: '规格',
      turthQty: '实际开单量',
      unReciveQty: '待处理量',
      promiseDate: '承诺日期',
      promiseQty: '承诺数量'
    }
  }
}
